module.exports = __webpack_public_path__ + "cement/img/关于2.cb138ead.jpg";